import { useMemo } from "react";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import BoxSubtitle from "pro-features/components/BoxSubtitle/src/BoxSubtitle";
import DurationService from "app/services/DurationService";
import { useCurrentStateAndParams } from "@uirouter/react";
import { getCompareStripedCircleGradient } from "../utils/getCompareStripedCircle";

const { carbon } = colorsPalettes;

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 12px 12px 12px 24px;
    border-bottom: 1px solid ${carbon[100]};
    align-items: center;
`;

export const DurationFilter = () => {
    const { params } = useCurrentStateAndParams();
    const { duration, comparedDuration } = params;

    const { from, to, compareFrom, compareTo } = useMemo(
        () => DurationService.getDurationData(duration, comparedDuration).forAPI,
        [duration, comparedDuration],
    );

    const subtitleFilters = [
        {
            filter: "date",
            value: {
                from,
                to,
                compareFrom,
                compareTo,
                coloredBullets: {
                    dateBullet: carbon[200],
                    compareDateBullet: getCompareStripedCircleGradient(carbon[200]),
                },
            },
        },
    ];

    return <BoxSubtitle filters={subtitleFilters} />;
};
